module.exports = __webpack_public_path__ + "static/media/SBI_LOGO.35ff6f11.png";